import styled from "styled-components";
import { FlexRow, FlexRowDiv } from "./common.styles";
import { AdminFormSection } from "./AdminFormShared.styles";
import { colors } from "healthex-common/colors";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "./HXMobilePage.styles";
export const AdminDataSourceForm = styled(AdminFormSection) `
    margin-top: 16px;
`;
export const DataSourceWizardParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) ``;
export const DataSourceWizardContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    flex: 1 0 0;
    padding: 24px;
`;
export const DataSourceWizardFooterContainer = styled(FlexRowDiv) `
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-top: 1px solid ${colors.black_12};
`;
export const DataSourceWizardFooterActions = styled(FlexRow) `
    flex: 1;
    gap: 16px;
    justify-content: flex-end;
`;
